import type { AppContext } from '@application/context/AppContext';
import { recordAuditEvent } from '@application/audit/AuditDirectoryService';
import { loadPeriodesCloturees, savePeriodesCloturees } from '@application/comptabilite/PeriodesCloturees';
import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import type { DepsCloture } from './CloturePeriode';

/** Branche les ports de clôture sur le contexte applicatif et les magasins de l'entreprise. */
export function depsClotureDepuisContexte(ctx: AppContext, tenantId: string): DepsCloture {
  return {
    listEcritures: () => ctx.ecritures.list(),
    addEcriture: (e) => ctx.ecritures.add({ ...e, tenant_id: e.tenant_id || tenantId }),
    deleteEcriture: (id) => ctx.ecritures.delete(id),
    loadCloturees: () => loadPeriodesCloturees(tenantId),
    saveCloturees: async (p) => {
      await savePeriodesCloturees(tenantId, p);
    },
    saveSceau: (periode, sceau) =>
      SecureTenantStore.setJson(
        tenantId,
        `compta.sceau.${periode}`,
        sceau ? { periode, ...sceau, scelle_le: new Date().toISOString() } : null,
      ),
    audit: (input) => recordAuditEvent(ctx, input),
  };
}
